import Vue from "vue";
import config from "@/config";
import errorTags from "@/errorTags";
import router from "@/router";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    language: "en"
  },
  mutations: {  },
  actions: {
    launchLive22(context, user) {
      const url = config.launchLive22();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchLive22.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              router.push("/").catch(err => {});
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLive22Result(context, user) {
      const url = config.getLive22Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getGameResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getGameResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchUuslot(context, user) {
      const url = config.launchUuslot();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchUuslot.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchUuslot.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchUuslot.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getUuResult(context, user) {
      const url = config.getUuResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchPPS(context, user) {
      const url = config.launchPPS();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        game_code: user.game_code,
        mobile: user.mobile
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchPPS.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchPPS.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchPPS.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPPSResult(context, user) {
      const url = config.getPPSResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchPPC(context, user) {
      const url = config.launchPPC();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        mobile: user.mobile
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchPPC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchPPC.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchPPC.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.game_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPPCResult(context, user) {
      const url = config.getPPCResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchYB(context, user) {
      const url = config.launchYB();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        mobile: user.mobile
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchYB.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchYB.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchYB.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "0";
                } else {
                  feedback.success = successResponse.body.status == 0;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.game_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchWB(context, user) {
      const url = config.launchWB();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        type: user.type
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchWB.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchWB.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchWB.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.game_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchEVO(context, user) {
      const url = config.launchEVO();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        mobile: user.mobile
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEVO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEVO.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEVO.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.game_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getEVOResult(context, user) {
      const url = config.getEVOResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchEpic(context, user) {
      const url = config.launchEpic();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEpic.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEpic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEpic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              router.push("/").catch(err => {});
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getEpicResult(context, user) {
      const url = config.getEpicResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getGameResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getGameResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchMega(context, user) {
      const url = config.launchMega();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchMega.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchMega.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchMega.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              router.push("/").catch(err => {});
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMegaResult(context, user) {
      const url = config.getMegaResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getGameResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getGameResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getGameResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
}